export default function AvatarCircle({ src, alt = '' }) {
    return (
        <div className='w-10 h-10 flex overflow-hidden relative text-xl leading-none items-center shrink-0 rounded-full justify-center'>
            <img className='text-transparent w-full h-full object-cover text-center' src={src} alt={alt} />
        </div>
    )
}